import { render, staticRenderFns } from "./inviteCompanyInfo.vue?vue&type=template&id=83ebd230&scoped=true&"
import script from "./inviteCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./inviteCompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./inviteCompanyInfo.vue?vue&type=style&index=0&id=83ebd230&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ebd230",
  null
  
)

export default component.exports